<template>
  <div id="highSearch_dialog">
    <div class="searchCondition">
      <el-form ref="form" :model="searchInfo" label-width="90px">
        <!-- 主题 -->
        <el-form-item :label="$t('subject')">
          <el-input v-model="searchInfo.subject"></el-input>
        </el-form-item>
        <!-- 发件人 -->
        <el-form-item :label="$t('from')">
          <el-input v-model="searchInfo.sender"></el-input>
        </el-form-item>
        <!-- 收件人 -->
        <el-form-item :label="$t('to')">
          <el-input v-model="searchInfo.consignee"></el-input>
        </el-form-item>
        <!-- 开始时间 -->
        <el-form-item :label="$t('startTime')" class="search_time">
          <div class="searchStart_date">
            <el-date-picker v-model="searchTime.startDate" type="date" @change="searchStartDate" :placeholder="$t('optionDate')">
            </el-date-picker>
          </div>
          <!-- <div class="searchStart_time">
            <el-time-picker v-model="searchTime.startTime"
                            format="HH:mm"
                            @change="searchStartTime"
                            placeholder="选择时间">
            </el-time-picker>
          </div> -->
          <!--结束时间-->
          <span class="searchEnd_tabel">{{$t('endTime')}}：</span>
          <div class="searchEnd_date">
            <el-date-picker v-model="searchTime.endDate" type="date" @change="searchEndDate" :placeholder="$t('optionDate')">
            </el-date-picker>
          </div>
          <!-- <div class="searchEnd_time">
            <el-time-picker v-model="searchTime.endTime"
                            format="HH:mm"
                            @change="searchEndTime"
                            placeholder="选择时间">
            </el-time-picker>
          </div> -->
        </el-form-item>
        <!-- 文件夹 -->
        <el-form-item :label="$t('folder')">
          <el-select v-model="searchInfo.folderName" placeholder="请选择">
            <div v-for="(item,index) in searchFolderArr" :key="index">
              <!-- 文件夹名称 -->
              <el-option :label="folderNameLang(item.DisplayName)" :value="item.DisplayName"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <!-- 附件 -->
        <el-form-item :label="$t('attachments')">
          <el-radio-group v-model="searchInfo.isattachment">
            <el-radio label="">{{$t('noRestrictions')}}</el-radio>
            <el-radio :label='true'>{{$t('includeAttachments')}}</el-radio>
            <el-radio :label='false'>{{$t('excludeAttachments')}}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="button">
        <div>
          <!-- 搜索 -->
          <el-button type="primary" @click="searchFn">{{$t('search')}}</el-button>
          <!-- 取消 -->
          <el-button @click="$emit('hideHighSearchDialog')">{{$t('cancel')}}</el-button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "highSearch_dialog",
  props: [],
  components: {},
  data() {
    return {
      searchInfo: {
        subject: "", //主题
        sender: "", //发件人
        consignee: "", //收件人
        time: "", //时间
        content: "", //详情内容
        folderName: "", //文件夹名称
        folderId: "", //文件夹id
        isattachment: "", //附件，不限，含附件，不含附件
        FolderType: "" //当前所在文件夹的标识，1-收件箱；2-草稿箱；3-已发送；4-已删除；5-垃圾箱；6-收藏夹(默认0-无分类)
      },
      searchFolderArr: [],
      //搜索---开始时间、结束时间
      searchTime: {
        startDate: "",
        //向后端接口传参的时间字段需要00:00:00
        startTime: "00:00:00",
        endDate: "",
        //向后端接口传参的时间字段需要23:59:59
        endTime: "23:59:59"
      }
    }
  },
  methods: {
    // 文件夹名称-中英文切换
    folderNameLang(val) {
      if (val == "收件箱" || val.toLowerCase() == "inbox") {
        // 收件箱
        return this.$t("inbox")
      } else if (val == "草稿箱" || val.toLowerCase() == "drafts") {
        // 草稿箱
        return this.$t("drafts")
      } else if (val == "已发送" || val.toLowerCase() == "sent items") {
        // 已发送
        return this.$t("sendItems")
      } else if (val == "已删除" || val.toLowerCase() == "deleted items") {
        // 已删除
        return this.$t("deletedItems")
      } else if (val == "垃圾箱" || val.toLowerCase() == "junk email") {
        // 垃圾箱
        return this.$t("junkEmail")
      } else {
        // 其他
        return val
      }
    },
    //起始日期选定时
    searchStartDate(val) {
      console.log(val)
    },
    //起始时间选定时
    searchStartTime() {},
    //结束日期选定时
    searchEndDate() {},
    //结束时间选定时
    searchEndTime() {},
    //时间转换
    transformTime(value, type) {
      var date = new Date(value)
      var Y = date.getFullYear(),
        m = date.getMonth() + 1,
        d = date.getDate(),
        H = date.getHours(),
        i = date.getMinutes(),
        s = date.getSeconds()
      if (m < 10) {
        m = "0" + m
      }
      if (d < 10) {
        d = "0" + d
      }
      if (H < 10) {
        H = "0" + H
      }
      if (i < 10) {
        i = "0" + i
      }
      if (s < 10) {
        s = "0" + s
      }
      if (!value) {
        return " "
      } else {
        //return Y + "-" + m + "-" + d + " " + H + ":" + i + ":" + s
        if (type == "日期") {
          return Y + "-" + m + "-" + d
        } else if (type == "时间") {
          return H + ":" + i + ":" + s
        }
      }
    },
    //会议时间的验证
    searchTimeVerify() {
      let start = new Date(this.transformTime(this.searchTime.startDate, "日期"))
      let end = new Date(this.transformTime(this.searchTime.endDate, "日期"))
      //有开始时间且没有开始日期
      if (!this.searchTime.startDate) {
        // 请选择搜索的开始日期
        this.$message({
          showClose: true,
          message: this.$t("selectStartSearchTime"),
          type: "warning"
        })
        return false
      }
      //有结束时间且没有结束日期
      if (!this.searchTime.endDate) {
        // 请选择搜索的结束日期
        this.$message({
          showClose: true,
          message: this.$t("selectEndSearchTime"),
          type: "warning"
        })
        return false
      }
      //结束时间早于开始时间
      if (start > end) {
        // 您选择的结束时间早于开始时间
        this.$message({
          showClose: true,
          message: this.$t("startEarlyEnd"),
          type: "warning"
        })
        return false
      }
      return true
    },
    //搜索
    searchFn() {
      //文件夹id
      this.searchFolderArr.forEach((el, index) => {
        if (el.DisplayName == this.searchInfo.folderName) {
          this.searchInfo.folderId = el.Id
        }
      })
      //搜索时间
      if (!this.searchInfo.time) {
        this.searchInfo.time = ""
      }
      //当前所在文件夹标识
      switch (this.searchInfo.folderName) {
        case "收件箱":
          this.searchInfo.FolderType = 1
          break
        case "草稿箱":
          this.searchInfo.FolderType = 2
          break
        case "已发送":
          this.searchInfo.FolderType = 3
          break
        case "已删除":
          this.searchInfo.FolderType = 4
          break
        case "垃圾箱":
          this.searchInfo.FolderType = 5
          break
      }
      let query = {
        folderId: this.searchInfo.folderId,
        level: 0, //0：根目录
        DisplayName: encodeURIComponent(this.searchInfo.folderName),
        FolderType: this.searchInfo.FolderType,
        //以下为高级搜索参数
        Subject: this.searchInfo.subject, //主题
        Sender: this.searchInfo.sender, //发件人
        DisplayTo: this.searchInfo.consignee, //收件人
        DateTimeReceivedStart: this.transformTime(this.searchTime.startDate, "日期") + " " + this.searchTime.startTime, //开始时间
        DateTimeReceivedEnd: this.transformTime(this.searchTime.endDate, "日期") + " " + this.searchTime.endTime, //结束时间
        HasAttachments: this.searchInfo.isattachment, //是否带有附件
        searchType: "高级搜索"
      }
      //搜索时间验证
      if (!this.searchTimeVerify()) return
      //文件夹验证
      if (!this.searchInfo.folderName) {
        // 请选择文件夹
        this.$message({
          showClose: true,
          type: "warning",
          message: this.$t("selectFolder")
        })
        return
      }
      //验证通过后进行搜索
      this.$emit("hideHighSearchDialog")
      this.$router.push({path: "/index", query})
      // this.searchInfo.folderName = "收件箱"
      this.searchInfo.folderName = this.searchFolderArr[0].DisplayName
    },
    //获取文件夹信息
    getFloderId() {
      this.$api.get(
        `/${this.$utils.getApiPrefix().exchangeapi}/folders`,
        {},
        r => {
          if (r.Success === true) {
            this.searchFolderArr = r.Data
            this.searchInfo.folderName = r.Data[0].DisplayName
          }
        },
        e => {}
      )
    }
  },
  created() {
    this.getFloderId()
  },
  mounted() {},
  watch: {},
  filters: {}
}
</script>
<style scoped lang="scss">
#highSearch_dialog {
  .searchCondition {
    > .button {
      height: 70px;
      position: relative;
      > div {
        position: absolute;
        right: 50px;
        top: 0;
      }
    }
  }
  .search_time {
    .searchEnd_tabel {
      margin-left: 30px;
    }
    .el-form-item__content {
      > div {
        display: inline-block;
        width: 190px;
        .el-input {
          width: 100%;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/highSearchDialog.vue